<template>
  <div class="TodayScheWidget">
    <p>当天的课程</p>
    <div class="d_list pl-5">
        <p v-for="item in datas">{{item.information}}  /  {{ item.address }}  :  {{ item.schedulingStatus? '已结束' : '未结束' }} / {{ item.timeDuration }}</p>
    </div>

  </div>
</template>


<script>

import { schedulingTodayApi } from "@/api/module/scheduling/scheduling";


export default {
  name: "TodayScheWidget",
  // props:{
  //   multiple: {
  //     type : Boolean,
  //     default: true
  //   }
  // },
  data() {
    return {
      datas: [],
      loading : false
    }
  },
  methods:{
    init() {
      
      schedulingTodayApi()
        .then((res)=>{
            this.datas = res;
        })


    },
  },
  
  mounted() {
    this.init();
  }
}
</script>



<style scoped>
.title {
  font-size: 13px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}
</style>